<template>
  <div>
    <h1 class="display-4">Liste des utilisateurs</h1>
    <hr />
    <p>
      <!-- <a class="btn btn-large btn-primary" href="https://www.ionis-support.com/account/list" target="_blank">Ajouter un utilisateur</a> -->
      <router-link to="/user/edit">
        <span class="btn btn-large btn-primary">Ajouter un utilisateur</span>
      </router-link>
    </p>

    <b-table class="mt-3" :dark="theme == 'dark'" responsive hover striped :items="users" :fields="fields" :current-page="currentPage" :per-page="perPage" v-show="totalRows > 0">
      <template slot="active" slot-scope="cell">
        <font-awesome-icon icon="check-circle" class="text-success" v-show="cell.item.active" />
        <font-awesome-icon icon="times-circle" class="text-danger" v-show="!cell.item.active" />
      </template>
      <template slot="actions" slot-scope="cell">
        <router-link tag="a" class="btn btn-sm btn-primary" :to="{ name: 'UserEdit', params: {id: cell.item.id } }">
          Editer
        </router-link>
      </template>
    </b-table>

    <b-row v-show="totalRows > perPage">
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>

    <p class="text-center" v-show="totalRows == 0"><em>Il y a aucun utilisateurs pour le moment...</em></p>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import Paginate from 'vuejs-paginate'

Vue.component('paginate', Paginate)
Vue.use(VueResource)

export default {
  data () {
    return {
      currentPage: 1,
      fields: {
        last_name: {
          label: 'Nom',
          sortable: false
        },
        first_name: {
          label: 'Prénom',
          sortable: false
        },
        email: {
          last_name: 'Email'
        },
        role: {
          label: 'Rôle',
          sortable: false
        },
        active: {
          label: 'Actif',
          sortable: false
        },
        actions: {
          label: 'Actions',
          key: 'actions'
        }
      },
      users: [],
      perPage: 20,
      total: 0
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain', 'theme']),
    totalRows () {
      return this.users.length
    }
  },
  mounted () {
    this.$http.get(this.domain + '/api/ionis?access_token=' + this.access_token).then((response) => {
      response.json().then((data) => {
        this.users = data
      })
    }, (response) => {

    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Users/List.vue